import React from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import styles from './TermsPage.module.css'; // Import as a module

export default function TermsPage() {
  // Initialize useTranslation for the 'terms' namespace
  const { t } = useTranslation('terms');

  // Fetch translated content using t-keys
  const pageTitle = t('terms.title', 'General Terms and Conditions (GTC)');
  const effectiveDate = t('terms.valid_from', 'Valid from: Unknown Date');
  
  // Fetch the entire sections object, ensuring it returns an object
  const sections = t('terms.sections', { returnObjects: true });

  // Check if sections is an object and has keys, otherwise display an error
  if (!sections || typeof sections !== 'object' || Object.keys(sections).length === 0) {
    return <div className={styles.container}>No terms and conditions sections found or data format is incorrect.</div>;
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.pageTitle}>{pageTitle}</h1>
      <p className={styles.effectiveDate}><strong>{effectiveDate}</strong></p>
      <p className={styles.effectiveDate}>{t('Ver. 1.0')}</p>
      
      

      {/* Iterate over the sections object fetched from translations */}
      {Object.entries(sections).map(([key, section]) => (
        <div key={key} className={styles.sectionContainer}>
          <h2 className={styles.sectionTitle}>{section.title}</h2>
          <p className={styles.sectionBody}>{section.body}</p>
        </div>
      ))}
    </div>
  );
}
